import React from 'react';
import { Container, Paper, Box, Typography } from '@mui/material';
import ForgotPasswordForm from '../components/auth/ForgotPasswordForm';
import TimeDisplay from '../components/TimeDisplay';
import ThemeToggle from '../components/ThemeToggle';

const ForgotPasswordPage: React.FC = () => {
  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, px: 2 }}>
        <TimeDisplay />
        <ThemeToggle />
      </Box>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom>
            Forgot Password
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Enter your email to receive a password reset link
          </Typography>
        </Box>
        <ForgotPasswordForm />
      </Paper>
    </Container>
  );
};

export default ForgotPasswordPage;
